<template>
    <v-container>
        <v-row class="align-center">
            <v-col cols="6"
                   xl="5"
                   lg="5">
                <v-menu
                        v-model="menuFrom"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                                v-model="dateFrom"
                                label="From"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                            v-model="dateFrom"
                            @input="menuFrom = false"
                    ></v-date-picker>
                </v-menu>
            </v-col>
            <v-col xl="5"
                   lg="5"
                   cols="6"
            >
                <v-menu
                        v-model="menuTo"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                                v-model="dateTo"
                                label="To"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                            v-model="dateTo"
                            @input="menuTo = false"
                    ></v-date-picker>
                </v-menu>
            </v-col>
            <v-col cols="2" class="text-right">
                <v-btn color="primary" @click="loadData">Refresh graph</v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <highcharts :options="chart" catchLegendEvents="true"/>
            </v-col>
        </v-row>
        <v-row class="align-center">
            <v-col cols="6"
                   xl="3"
                   lg="3">
                <v-menu
                        v-model="menuAddFrom"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                                v-model="dateAddFrom"
                                label="From"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                            v-model="dateAddFrom"
                            @input="menuAddFrom = false"
                    ></v-date-picker>
                </v-menu>
            </v-col>
            <v-col xl="3"
                   lg="3"
                   cols="6"
            >
                <v-menu
                        v-model="menuAddTo"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                                v-model="dateAddTo"
                                label="To"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                            v-model="dateAddTo"
                            @input="menuAddTo = false"
                    ></v-date-picker>
                </v-menu>
            </v-col>
            <v-col cols="3">
                <v-checkbox v-model="forceUpdate" label="Force update"></v-checkbox>
            </v-col>
            <v-col cols="3" class="text-right align-center">
                <v-btn color="primary" @click="updateData">Update data</v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import constants from "../constants";

    export default {
        name: "AllStepsView",
        data: () => ({
            dateTo: new Date().toISOString().substr(0, 10),
            menuTo: false,
            dateFrom: new Date(new Date().setDate(new Date().getDate() - 7)).toISOString().substr(0, 10),
            menuFrom: false,
            dateAddFrom: new Date(new Date().setDate(new Date().getDate() - 7)).toISOString().substr(0, 10),
            menuAddFrom: false,
            dateAddTo: new Date().toISOString().substr(0, 10),
            menuAddTo: false,
            chart: {
                credits: {
                    enabled: false
                },
                title: {
                    text: 'Daily ratio of connected trackers and step data'
                },
                xAxis: {
                    type: 'datetime',
                    labels: {
                        rotation: -45
                    }
                },
                yAxis: {
                    title: {
                        text: "Amount"
                    }
                },
                series: [
                    {
                        name: 'Participants',
                        data: []
                    },
                    {
                        name: 'Participants with steps',
                        data: []
                    }
                ]
            },
            forceUpdate: false
        }),
        mounted() {
            this.loadData();
        },
        methods: {
            loadData() {
                this.$http.get(constants.STEP_DATA_ALL_ENDPOINT, {
                    params: {
                        from: this.dateFrom,
                        to: this.dateTo
                    }
                })
                    .then((response) => {
                        this.chart.series[0].data = []
                        this.chart.series[1].data = []

                        response.data.forEach(element => {
                            this.chart.series[0].data.push([new Date(element.day).getTime(), element.participants])
                            this.chart.series[1].data.push([new Date(element.day).getTime(), element.participantsWithSteps])
                        })
                    })
                    .catch(error => {
                        console.log(error)
                    });
            },
            updateData() {
                this.$store.commit('setInfoMessage', 'Sent step update request for all users')
                this.$http.post(constants.STEP_UPDATE_ALL_ENDPOINT, {}, {
                    params: {
                        from: this.dateFrom,
                        to: this.dateTo,
                        forceUpdate: this.forceUpdate
                    }
                })
                    .then(() => {
                        this.$store.commit('setSuccessMessage', 'Successfully updated steps for all users')
                    })
                    .catch(error => {
                        console.log(error)
                    });
            }
        }
    }
</script>

<style scoped>

</style>
